<script setup lang="ts">
import type { ProfilPreviewModalContentProps } from "@/components/modal/Profile/previewProfile/types";

import PdfManager from "@/components/PdfManager.vue";

// biome-ignore lint/correctness/noUnusedVariables: Init Biome
const props = defineProps<ProfilPreviewModalContentProps>();
</script>

<template>
    <div class="profil-preview-modal-content">
        <div class="profil-preview-modal-content__section">
            <div class="profil-preview-modal-content__section__cv-wrapper">
                <PdfManager :path="cvPath ?? ''" readonly show-download />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.profil-preview-modal-content {
    display: flex;
    flex-direction: column;
    flex: 1 0 0;
    background-color: var(--bg-lightest-50, #f6f7f9);

    &__section {
        display: flex;
        justify-content: center;
        flex: 1 0 0;
        padding: var(--spacing-3xl, 24px) 0;
        overflow: auto;

        &__cv-wrapper {
            width: 600px;
            height: 1000px;
            border-radius: var(--radius-md, 8px);
            background-color: var(--bg-white-0, #ffffff);
            border: 0.5px solid var(--stroke-soft-200, #dbdfe6);
            box-shadow: var(--regular-shadow-lg, 0px 16px 40px 0px #3238481a);
        }
    }
}
</style>
